import { render, staticRenderFns } from "./PreferencesScaffold.vue?vue&type=template&id=965b1c96&"
import script from "./PreferencesScaffold.vue?vue&type=script&lang=ts&"
export * from "./PreferencesScaffold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports